export const setLocal = (key, value) => {
  if (typeof window != 'undefined') {
    const item = localStorage.setItem(key, value)
    return item
  }
}

export const getLocal = (key) => {
  if (typeof window != 'undefined') {
    const item = localStorage.getItem(key)
    return item
  }
}

export const removeLocal = (key) => {
  if (typeof window != 'undefined') {
    const item = localStorage.removeItem(key)
    return item
  }
}

// export const isAuthToken = localStorage.getItem('authToken') ? true : false
export const isAuthToken = localStorage.getItem('authToken') ? true : false

export const clearLocalStorage = () => {
  localStorage.clear()
  removeLocal('persist:userInfo')
}

export const getAuthToken = () => localStorage.getItem('authToken')
